import { render, staticRenderFns } from "./licensePagination.vue?vue&type=template&id=5707ec37"
import script from "./licensePagination.vue?vue&type=script&lang=js"
export * from "./licensePagination.vue?vue&type=script&lang=js"
import style0 from "./licensePagination.vue?vue&type=style&index=0&id=5707ec37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports